import VwIdentityKit from './VwIdentityKit';
import { getUserData, isUserDataValid } from './LoginService';
import REQUEST from '../../shared/http-request-util';

let { identityKitOption } = require('../../shared/constants');

/**
 * 
 * @param {*} props 
 */
/**
 * Get redirect url to login
 */
export function handleLogin(props) {
  //Web
  if (window.location.search.indexOf('code') !== -1) {
    var matches = /code=([^&#=]*)/.exec(window.location.search);
    var code = matches[1];
    new VwIdentityKit(identityKitOption()).getInfoFromCode(code)
      .then(properties => {
        // USER IS LOGGED -> GET user info and garage
        getUserData(properties)
          .then(userDB => {
            userDB.user.token = properties.token
            localStorage.setItem('user-data', JSON.stringify(userDB.user));
            handleLoggedInUser(props, userDB);
          })
          .catch(err => {
            let userData = {
              token: properties.token,
              code: properties.code,
              email: properties.email
            }
            localStorage.setItem('user-data', JSON.stringify(userData));
            props.history.push('/login')
          })
      }).catch((err) => {
        console.log(err)
        // props.history.push('/login')
        REQUEST()._handleErrorRedirect(err)
      })
  } else {
    window.location.href = new VwIdentityKit(identityKitOption()).mountRedirectUrl();
  }
  return null;
}

export function handleLoggedInUser(props, userDB) {
  let userData = JSON.parse(localStorage.getItem('user-data'));
  userData.loggedIn = true;
  // userData.token = true;
  localStorage.setItem('user-data', JSON.stringify(userData));
  handleRedirect(props, userDB);
}

export function handleRedirect(props, userDB) {
  let hasCars = userDB.garage && userDB.garage.length <= 0 ? false : true
  if (isUserDataValid(userDB.user) && !hasCars) {
    //If user has filled  info, but has NO CARS
    props.history.push({
      pathname: '/vehicle-form',
      state: { ...userDB }
  })
  } else if (isUserDataValid(userDB.user) && hasCars) {
    //If user has filled  info, and has CARS
    props.history.push({
      pathname: '/',
      state: { ...userDB }
    })
  } else if (!isUserDataValid(userDB.user)) {
    //If user NO filled  info
    props.history.push('/user-form')
  } else {
    props.history.push('/error')
  }
}